<template>
  <div class="pa-0 ma-0">
    <v-toolbar app fixed color="accent">
      <div class="eventsNotificationContainer" @click.stop="sideDrawerToggle">
        <v-icon color="primary">{{ show ? 'mdi-map' : 'mdi-text' }}</v-icon>
        <div class="eventsGetNotification" v-if="notification > 0">{{ notification }}</div>
      </div>
      <v-toolbar-title class="headline text-uppercase"> <span>Evntl Virus Watch</span> </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-show="false" @click="testPush"> push </v-btn>
      <MenuDropdown />
      <v-menu auto offset-y bottom class="dropdown" v-if="false">
        <v-avatar slot="activator" class="mr-5"> <img :src="profile.picture" /> </v-avatar>
        <v-list>
          <v-list-tile avatar ripple @click="signOut">
            <v-list-tile-avatar> <v-icon>mdi-exit-to-app</v-icon> </v-list-tile-avatar>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
          <v-list-tile avatar ripple @click="sendInvite">
            <v-list-tile-avatar> <v-icon>mdi-account-plus-outline</v-icon> </v-list-tile-avatar>
            <v-list-tile-title>Send Invite</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-navigation-drawer class="drawer" v-model="show" mobile-break-point="0" app width="450" id="navigation">
      <SideDrawer @eventClickedTwo="drawerClose" />
    </v-navigation-drawer>
    <div @click.stop="sideDrawerToggle" class="bottomBar" v-if="mobileState">
      <v-icon class="mt-1 mb-1 ml-3" color="primary">mdi-arrow-left</v-icon>
      <div class="mt-2 mb-2 ml-1">To List</div>
    </div>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer';
import MenuDropdown from '@/components/MenuDropdown';
import { mapGetters } from 'vuex';

export default {
  name: 'ToolBar',
  components: {
    SideDrawer,
    MenuDropdown
  },
  props: {
    profile: {
      type: Object
    },
    loggedIn: {
      type: Boolean
    }
  },
  data() {
    return {
      show: true,
      scroller: null
    };
  },
  watch: {
    show(newValue) {
      this.$store.commit('generalUpdateSideDrawer', newValue);
    }
  },
  computed: {
    ...mapGetters({
      mobileState: 'generalGetMobileState',
      notification: 'eventsGetNotification'
    })
  },
  mounted() {
    this.scroller = window.document.getElementById('navigation');
    this.scroller.addEventListener('scroll', this.randomFunction);
  },
  methods: {
    signOut() {
      this.$store.dispatch('User/logOut');
    },
    sideDrawerToggle() {
      this.show = !this.show;
    },
    drawerClose() {
      if (this.mobileState) {
        if (this.show) {
          this.show = false;
        }
      }
    },
    randomFunction() {
      let sh = this.scroller.scrollHeight;
      let st = this.scroller.scrollTop;
      if (st > sh / 2) {
        this.$store.dispatch('eventsNextPage');
      } else {
        this.$store.commit('eventsToggleEndOfList', false);
      }
    },
    sendInvite() {
      this.$router.replace('invitation');
    },
    testPush() {
      // this.$http.post('/new-events', {
      //   events: [
      //     {
      //       _index: 'news_collector-2018.10.03-000005',
      //       _type: 'news',
      //       _source: {
      //         eventPublishTime: 1549041530274,
      //         attachments: [
      //           { imageUrl: 'http://pbs.twimg.com/media/DyVhCfbW0AAYdbu.jpg', type: 'photo', url: 'http://pbs.twimg.com/media/DyVhCfbW0AAYdbu.jpg' },
      //           { imageUrl: 'http://pbs.twimg.com/media/DyVhCPvWwAAMTQG.jpg', type: 'photo', url: 'http://pbs.twimg.com/media/DyVhCPvWwAAMTQG.jpg' },
      //           { imageUrl: 'http://pbs.twimg.com/media/DyVhB-oWkAATCjp.jpg', type: 'photo', url: 'http://pbs.twimg.com/media/DyVhB-oWkAATCjp.jpg' }
      //         ],
      //         eventCategory: 'Plc',
      //         channel: 'all',
      //         tweets: [
      //           {
      //             type: 'text',
      //             categoryName: 'Plc',
      //             status: {
      //               id: 1091384516420268032,
      //               text:
      //                 '...were jointly charged with malicious damage of the officer\u2019s clothing. Afiesha and Keisha were also charged with using obscene language, resisting arrest and disorderly behavior, while Afiesha faced an additional charge of assault occasioning actual bodily harm...'
      //             }
      //           },
      //           {
      //             urls: ['https://twitter.com/WWYD_TT/status/1091385180345040897/photo/1'],
      //             type: 'photo',
      //             categoryName: 'Plc',
      //             status: {
      //               id: 1091385180345040897,
      //               text:
      //                 'RT TTPoliceService : ... against a police officer, resulting in him sustaining a broken bone in his left hand. A seventh accused, CHERON ALEXANDER, 51, was charged with using obscene language, resisting arrest and obstructing a police officer in the execution of his duties. \u2026 https://t.co/AOP4pl2Ulh'
      //             }
      //           },
      //           {
      //             urls: ['https://twitter.com/WWYD_TT/status/1091385176222040064/photo/1'],
      //             type: 'photo',
      //             categoryName: 'Plc',
      //             status: {
      //               id: 1091385176222040064,
      //               text:
      //                 'RT TTPoliceService : ...were jointly charged with malicious damage of the officer\u2019s clothing. Afiesha and Keisha were also charged with using obscene language, resisting arrest and disorderly behavior, while Afiesha faced an additional charge of assault occasioning actual bo\u2026 https://t.co/BAoUWjZnws'
      //             }
      //           },
      //           {
      //             urls: ['https://twitter.com/WWYD_TT/status/1091385171578970120/photo/1'],
      //             type: 'photo',
      //             categoryName: 'Plc',
      //             status: {
      //               id: 1091385171578970120,
      //               text:
      //                 'RT TTPoliceService : Meanwhile, arising out of the incident, AFIESHA TIMOTHY, 34, KEISHA TIMOTHY, 18, AQUIMER DOWERS, 31, and, MATTHEW ALEXANDER, 23, also of Mohammed Street, St. Augustine, were jointly charged with assaulting a police officer, while Afiesha, Keisha and Matt\u2026 https://t.co/7G5sBB3aod'
      //             }
      //           }
      //         ],
      //         categoriesM: [],
      //         eventTitle:
      //           '...were jointly charged with malicious damage of the officer\u2019s clothing. Afiesha and Keisha were also charged with using obscene language, resisting arrest and disorderly behavior, while Afiesha faced an additional charge of assault occasioning actual bodily harm...',
      //         tweetLocation: [],
      //         eventLocationName: 'Trinidad and Tobago',
      //         eventImportance: 'Information',
      //         eventCountryName: 'Trinidad and Tobago',
      //         subChannel: 'news',
      //         eventTime: 1549041501855,
      //         magnitude: 1.39,
      //         text:
      //           '...were jointly charged with malicious damage of the officer\u2019s clothing. Afiesha and Keisha were also charged with using obscene language, resisting arrest and disorderly behavior, while Afiesha faced an additional charge of assault occasioning actual bodily harm...',
      //         categories: ['Plc'],
      //         timestamp: 1549041501855,
      //         eventScope: 'Local',
      //         eventRegionCode: 'NA',
      //         meter: 4,
      //         eventCountry: 'TT',
      //         eventLocation: '10.691803,-61.222503',
      //         count: 4,
      //         userLocation: ['11.2336911,-60.69889089999999', '10.691803,-61.222503', '10.691803,-61.222503', '10.691803,-61.222503'],
      //         reviewer: 'brody',
      //         executionTime: 1549041497132,
      //         entityname_surface: [
      //           'accus',
      //           'afiesha',
      //           'afiesha timothi',
      //           'alexand',
      //           'aquim',
      //           'aris',
      //           'arrest',
      //           'assault',
      //           'augustin',
      //           'behavior',
      //           'bo',
      //           'bodili',
      //           'bone',
      //           'broken',
      //           'cheron',
      //           'cheron alexand',
      //           'damag',
      //           'disorderli',
      //           'dower',
      //           'duti',
      //           'execut',
      //           'harm',
      //           'incid',
      //           'jointli',
      //           'keisha',
      //           'languag',
      //           'malici',
      //           'matt',
      //           'matthew',
      //           'matthew alexand',
      //           'meanwhil',
      //           'moham',
      //           'obscen',
      //           'obstruct',
      //           'occas',
      //           'polic',
      //           'resist',
      //           'seventh',
      //           'sustain',
      //           'timothi',
      //           'ttpoliceservic'
      //         ],
      //         eventStatus: 'Dismissed',
      //         semanticLocation: []
      //       },
      //       _id: 'OR4RqmgBx_-4V_RZhrfI',
      //       _score: 4
      //     }
      //   ]
      // });
    }
  }
};
</script>

<style scoped>
.dropdown {
  z-index: 230;
}
.drawer {
  background-color: #eaeef7;
}
.eventsNotificationContainer {
  position: relative;
}
.eventsGetNotification {
  position: absolute;
  bottom: -0.8rem;
  right: -0.8rem;
  background: maroon;
  color: white;
  font-size: 0.9rem;
  font-weight: bold;
  padding: 0.1rem 0.5rem;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
}
.bottomBar {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: auto;
  display: flex;
  z-index: 2;
  background: #eaeef7;
}
</style>
